/** LOGISPRD-14585: ISO-8601 Instant(날짜T시각, 선택 소수초, Z 또는 ±hh:mm 필수). 부수효과 없는 모듈(페이지 헬퍼도 import). */
const ISO_INSTANT = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/

/** 패턴 일치 + Date.parse 유효일 때만 true. */
export const isIsoInstant = (value: unknown): value is string =>
  typeof value === 'string' && ISO_INSTANT.test(value) && !Number.isNaN(Date.parse(value))
